
import DesignContentLayout from '@/layouts/design/DesignContentLayout';
import { mapMutations } from 'vuex';

export default {
  name: 'DesignComponentsHeader',
  components: { DesignContentLayout },
  created() {
    const mockApi = {
      fetchNoticeSummary: () =>
        Promise.resolve({ data: { notices_count: 8, has_new_notice: false } })
    };
    this.SET_API(mockApi);
    this.STORE_RESPONSE_DATA({ widget: { show_notices: true } });
  },
  methods: {
    ...mapMutations(['SET_API']),
    ...mapMutations('widget', ['STORE_RESPONSE_DATA'])
  }
};
